<template>
  <div class="kf-page">
    <van-nav-bar title="客服中心" left-arrow @click-left="goBack" />
    <div class="kf-hero">
      <div class="kf-hero__text">
        <h2>专业客服</h2>
        <p>为你答疑解惑</p>
      </div>
      <div class="kf-hero__art" aria-hidden="true">
        <svg viewBox="0 0 120 120" width="108" height="108">
          <circle cx="78" cy="38" r="22" fill="#fff" opacity="0.95" />
          <path
            d="M58 86c0-14 12-26 28-26s28 12 28 26v10H58V86z"
            fill="#fff"
            opacity="0.95"
          />
          <path
            d="M62 40c-10 2-18 12-18 24v8c-6 0-10 4-10 10v6h18V72c0-8 4-14 10-18V40z"
            fill="#ffe8d6"
          />
          <circle cx="96" cy="28" r="6" fill="#ff1900" />
        </svg>
      </div>
    </div>

    <div class="kf-body">
      <button type="button" class="kf-card" @click="openVip">
        <span class="kf-card__icon">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path
              fill="#fff"
              d="M4 6.5A3.5 3.5 0 017.5 3h9A3.5 3.5 0 0120 6.5v6A3.5 3.5 0 0116.5 16H10l-4.4 3.2A.8.8 0 014 18.6V6.5z"
            />
            <circle cx="8.5" cy="9.5" r="1.1" fill="#ff1900" />
            <circle cx="12" cy="9.5" r="1.1" fill="#ff1900" />
            <circle cx="15.5" cy="9.5" r="1.1" fill="#ff1900" />
          </svg>
        </span>
        <span class="kf-card__text">VIP客服专线</span>
        <i>›</i>
      </button>

      <button
        v-for="item in displayItems"
        :key="item.code"
        type="button"
        class="kf-card"
        @click="openItem(item)"
      >
        <span class="kf-card__icon">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path
              fill="#fff"
              d="M4 6.5A3.5 3.5 0 017.5 3h9A3.5 3.5 0 0120 6.5v6A3.5 3.5 0 0116.5 16H10l-4.4 3.2A.8.8 0 014 18.6V6.5z"
            />
            <circle cx="8.5" cy="9.5" r="1.1" fill="#ff1900" />
            <circle cx="12" cy="9.5" r="1.1" fill="#ff1900" />
            <circle cx="15.5" cy="9.5" r="1.1" fill="#ff1900" />
          </svg>
        </span>
        <span class="kf-card__text">{{ item.title }}</span>
        <i>›</i>
      </button>
    </div>

    <van-popup
      v-model="popup.show"
      round
      closeable
      :style="{ width: '86%', maxWidth: '360px' }"
    >
      <div class="kf-popup">
        <h3>{{ popup.title }}</h3>
        <img v-if="popup.image" :src="popup.image" alt="二维码" />
        <div v-if="popup.link" class="kf-popup__link">
          <p>{{ popup.link }}</p>
          <button type="button" @click="copyPopupLink">复制链接</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import request from "@utils/request";
import { goodsImage } from "@utils/goodsImage";

const FIXED_ITEMS = [
  { code: "tudou_qr", title: "土豆官方群组群码" },
  { code: "tudou_link", title: "土豆官方群组链接" },
  { code: "anxin_qr", title: "安信官方群组群码" },
  { code: "anxin_link", title: "安信官方群组链接" }
];

export default {
  name: "customerService",
  data() {
    return {
      vipLinks: [],
      items: [],
      popup: {
        show: false,
        title: "",
        image: "",
        link: ""
      }
    };
  },
  computed: {
    displayItems() {
      const map = {};
      (this.items || []).forEach(item => {
        if (item && item.code) {
          map[item.code] = item;
        }
      });
      return FIXED_ITEMS.map(fixed => {
        const row = map[fixed.code] || {};
        return {
          code: fixed.code,
          title: fixed.title,
          image: goodsImage(row.image),
          link: String(row.link || "").trim()
        };
      });
    }
  },
  mounted() {
    this.loadCenter();
    this.$root.$on("tab-refresh", this.onTabRefresh);
  },
  beforeDestroy() {
    this.$root.$off("tab-refresh", this.onTabRefresh);
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push("/");
    },
    onTabRefresh(url) {
      if (url === "/customerService") {
        this.loadCenter();
      }
    },
    loadCenter() {
      request
        .get("/api/v1/kefu/center", {}, { login: false })
        .then(res => {
          const payload = res && res.data ? res.data : res;
          const data = (payload && payload.data) || {};
          this.vipLinks = (data.vip_links || []).filter(Boolean);
          this.items = data.items || [];
        })
        .catch(() => {
          this.vipLinks = [];
          this.items = [];
        });
    },
    openVip() {
      const links = (this.vipLinks || []).filter(Boolean);
      if (!links.length) {
        this.$toast("暂未配置客服链接");
        return;
      }
      const url = links[Math.floor(Math.random() * links.length)];
      const win = window.open(url, "_blank");
      if (!win) {
        window.location.href = url;
      }
    },
    openItem(item) {
      const image = item && item.image ? item.image : "";
      const link = item && item.link ? item.link : "";
      if (!image && !link) {
        this.$toast("暂未配置");
        return;
      }
      this.popup = {
        show: true,
        title: item.title,
        image,
        link
      };
    },
    copyPopupLink() {
      const text = this.popup.link;
      if (!text) return;
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      el.setSelectionRange(0, el.value.length);
      document.execCommand("copy");
      el.remove();
      this.$toast.success("已复制链接");
    }
  }
};
</script>

<style scoped>
.kf-page {
  min-height: 100vh;
  padding-bottom: 70px;
  background: #f2f2f2;
}

.kf-page /deep/ .van-nav-bar {
  background: #ff1900;
}

.kf-page /deep/ .van-nav-bar__title,
.kf-page /deep/ .van-nav-bar .van-icon {
  color: #fff;
}

.kf-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 168px;
  padding: 18px 20px 28px;
  background: linear-gradient(135deg, #ff1900 0%, #ff5a1f 55%, #ff7a3a 100%);
  overflow: hidden;
}

.kf-hero__text h2 {
  margin: 0;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

.kf-hero__text p {
  margin: 8px 0 0;
  color: rgba(255, 255, 255, 0.92);
  font-size: 15px;
}

.kf-hero__art {
  flex-shrink: 0;
}

.kf-body {
  position: relative;
  z-index: 1;
  margin-top: -12px;
  padding: 0 12px 20px;
}

.kf-card {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
  padding: 14px 12px;
  border: 0;
  border-radius: 12px;
  background: #fff;
  text-align: left;
}

.kf-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  margin-right: 12px;
  border-radius: 50%;
  background: #ff1900;
}

.kf-card__text {
  flex: 1;
  min-width: 0;
  color: #333;
  font-size: 15px;
  line-height: 1.4;
}

.kf-card i {
  flex-shrink: 0;
  color: #c8c8c8;
  font-style: normal;
  font-size: 20px;
  line-height: 1;
}

.kf-popup {
  padding: 28px 18px 20px;
  text-align: center;
}

.kf-popup h3 {
  margin: 0 0 14px;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.kf-popup img {
  display: block;
  width: 100%;
  max-width: 240px;
  margin: 0 auto 12px;
  border-radius: 8px;
}

.kf-popup__link p {
  margin: 0 0 12px;
  color: #333;
  font-size: 13px;
  line-height: 1.6;
  word-break: break-all;
  user-select: all;
  -webkit-user-select: all;
}

.kf-popup__link button {
  width: 100%;
  height: 40px;
  border: 0;
  border-radius: 20px;
  background: #ff1900;
  color: #fff;
  font-size: 15px;
}
</style>
